import { useEffect, useState } from 'react';
import gamesService from '../../services/gamesService';
import type { GameEligibility, GameType } from '../../types/games';

export function useGameEligibility(appName: string, gameType: GameType) {
  const [loading, setLoading] = useState(true);
  const [eligibility, setEligibility] = useState<GameEligibility | null>(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    gamesService
      .getEligibility(appName, gameType)
      .then((res) => {
        if (active) setEligibility(res);
      })
      .catch(() => {
        if (active) {
          setEligibility({ eligible: false, gameType, reason: 'GAME_INACTIVE' });
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [appName, gameType]);

  return {
    loading,
    eligible: eligibility?.eligible ?? false,
    eligibility,
  };
}
